export const openAuthenticatedDocument = async (loadBlob) => {
  const popup = window.open("about:blank", "_blank");

  if (!popup) {
    throw new Error("Pop-up wurde vom Browser blockiert. Bitte erlaube Pop-ups für diese Seite.");
  }

  popup.opener = null;

  try {
    try {
      popup.document.open();
      popup.document.write(
        '<!doctype html><html lang="de"><head><meta charset="utf-8"><title>Vertragskopie wird geladen</title></head><body style="font-family:system-ui,sans-serif;padding:2rem;color:#334155">Vertragskopie wird geladen …</body></html>'
      );
      popup.document.close();
    } catch {
      // Das leere Fenster bleibt nutzbar, auch wenn der Browser keinen Zwischeninhalt erlaubt.
    }

    const blob = await loadBlob();
    const blobUrl = URL.createObjectURL(blob);
    popup.location.replace(blobUrl);
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  } catch (error) {
    popup.close();
    throw error;
  }
};
